export const CITY_DETAILS_TABS_NAMES = {
  COMMUNITIES: "Communities",
};

export const CITY_DETAILS_TABS = Object.values(CITY_DETAILS_TABS_NAMES).map(
  (name) => ({
    label: name,
    value: name,
  })
);
